import React, { useState, useEffect } from "react";
import "./styles/App.css";
import TopTitle from "./TopTitle";
import As_img from "./img/As_img.jpg";
import Abys_img from "./img/Abys_img.jpg";
import Hyundai_Capital_logo from "./img/mobile.png";
import queryString from "query-string";
import tag_h_logo from "./img/tag_h_logo.png";
import tag_sun_logo from "./img/tag_sun_logo.png";
import tag_sc_logo from "./img/tag_sc_logo.png";

import parse from "html-react-parser";
import { Cookies } from "react-cookie";
import { instance } from "./common";

function ServiceApply({ goCateNext, setBannerType }) {
  useEffect(() => {
    setBannerType("apply");
    return () => {
      console.log("url chk : ", window.location.href);
      if (
        window.location.href === "http://localhost:3000/" ||
        window.location.href === "https://abys-service.co.kr/"
      ) {
        setBannerType("main");
      }
    };
  }, []);

  const divCss = {
    borderRadius: "4px",
    height: "20vw",
    minHeight: "110px",
    background: "linear-gradient(#2F79D9, #80B0EF)",
    backgroundImage: "url(/img/main_hyundai.png)",
    backgroundPosition: "center",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
  };
  // TODO: /img/main_hyudae.png, /img/main_sungard.png

  const divCss2 = {
    borderRadius: "4px",
    height: "20vw",
    minHeight: "110px",
    backgroundImage: "url(" + Abys_img + ")",
    backgroundPosition: "center",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
  };

  const divCss3 = {
    borderRadius: "4px",
    height: "20vw",
    minHeight: "110px",
    background: "linear-gradient(#2F79D9, #80B0EF)",
    // backgroundImage:'url(/img/main_sungard.png)',
    backgroundImage: "url(" + As_img + ")",
    backgroundPosition: "center",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
  };

  const imgPosition = {
    height: "auto",
    maxWidth: "150px",
    width: "28%",
    position: "absolute",
    left: "50%",
    top: "37%",
    transform: "translate(-50%,-50%)",

    // maxWidth:"100%",
    minWidth: "120px",
    // minWidth:"60%"
  };

  const lineHeight = {
    lineHeight: "120px",
  };

  // const goService = (cate) => {
  //     if (query.r_id) {
  //         return history.push(`/serviceall?cate=${cate}&r_id=${query.r_id}`);
  //     }
  //     history.push(`/main/${cate}`);
  // };

  // const goServiceAll = (cate) => {
  //     if (query.r_id) {
  //         return history.push(`/serviceAll?cate=${cate}&r_id=${query.r_id}`);
  //     }
  //     history.push(`/serviceAll?cate=${cate}`);
  // }

  const Updating = () => {
    alert("업데이트 준비중입니다.");
  };
  const widthImg = {
    width: "100%",
  };

  const goHyundai = () => {
    window.location.replace("https://abys-service.co.kr/hyundai/before.php");
  };

  const resize = {
    width: "42px",
  };

  const wrap = {
    paddingTop: "15px",
    paddingBottom: "15px",
    borderRadius: "7px",
    border: "3px solid #fff",
    backgroundColor: "#F0F0F0",
    boxShadow: "5px 5px 15px 0px rgba(0,0,0,0.54)",
    color: "#1753A2",
    fontWeight: "bold",
  };

  // const session = JSON.parse(window.sessionStorage.result);
  const [popup, setPopup] = useState("");
  const [overlayVisible, setOverlayVisible] = useState(false);

  useEffect(() => {
    instance
      .post("/common/condition", { table: "popup", common: { po_first: "Y" } })
      .then(function (res) {
        console.log("res : ", res.data);
        if (res.data.length !== 0) {
          const cookies = new Cookies();
          if (cookies.get("sigong_popup")) {
          } else {
            console.log("res.data[0] : ", res.data[0]);
            setPopup(parse(res.data[0].po_content));
            setOverlayVisible(true);
          }
        }
      });
  }, []);

  const todayClose = () => {
    const cookies = new Cookies();
    const expires = new Date();
    expires.setDate(expires.getDate() + 1);
    cookies.set("sigong_popup", true, { path: "/", expires });
    setOverlayVisible(false);
  };

  return (
    <div>
      {overlayVisible && (
        <>
          <div className="popup-wrap">
            {popup}
            <div className="popup-bottom">
              <div onClick={() => todayClose()}>오늘은 그만 보기</div>
              <div onClick={(prev) => setOverlayVisible(!prev)}>닫기</div>
            </div>
          </div>
          <div className="popupBack"></div>
        </>
      )}
      <div className="main_bg"></div>
      <div className="cotainer bottom-bg">
        <div className="row mb-3 font-weight-bold">
          <p className="cate-title">주요 서비스</p>
        </div>
        <div className="row">
          <div className="col-6 pr-small pl-0 mb-4">
            <div className="box-cate-item" onClick={() => goCateNext("d2c")}>
              <div className="item-absolute">
                <img
                  src={tag_h_logo}
                  width="120px"
                  className="mb-2"
                  style={{ maxWidth: "100%" }}
                />
                <p className="mb-0">D2C 할부 신차패키지</p>
              </div>
            </div>
          </div>
          <div className="col-6 pl-small pr-0">
            <div className="box-cate-item" onClick={() => goCateNext("k")}>
              <div className="item-absolute">
                <img
                  src={tag_h_logo}
                  width="120px"
                  className="mb-2"
                  style={{ maxWidth: "100%" }}
                />
                <p className="mb-0">
                  K-Solution
                  <br />
                  카케어서비스
                </p>
              </div>
            </div>
          </div>
          <div className="col-6 pr-small pl-0">
            <div className="box-cate-item" onClick={() => goCateNext("sun")}>
              <div className="item-absolute">
                <img
                  src={tag_sun_logo}
                  width="120px"
                  className="mb-2"
                  style={{ maxWidth: "100%" }}
                />
                <p className="mb-0">신차패키지</p>
              </div>
            </div>
          </div>
          <div className="col-6 pl-small pr-0">
            <div className="box-cate-item" onClick={() => goCateNext("btob")}>
              <div className="item-absolute">
                <img
                  src={tag_sc_logo}
                  width="120px"
                  className="mb-2"
                  style={{ maxWidth: "100%" }}
                />
                <p className="mb-0">BtoB 카케어서비스</p>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="row">
              <div className="col-12 text-center mb-4" style={divCss3} onClick={() => goServiceAll('sungard')} >
                  <img src="/img/main_sungard.png" alt="" style={imgPosition} />
                  <p className="text-white mb-0" style={{ fontSize:"12px", marginTop:"10px", whiteSpace:"nowrap", position:"relative", top:"60%" }}>썬가드하이퍼 신차패키지</p>    
              </div>
              <div className="col-12 text-center mb-4 p-0" style={divCss} onClick={() => goHyundai()} >
              </div>
              <div className="col-12 text-center mb-4" style={divCss2} onClick={() => goServiceAll('BtoB')}>
                  <img src="/img/main_btob.png" alt="" style={imgPosition} />
                  <p className="text-white mb-0" style={{ fontSize:"12px", marginTop:"0", whiteSpace:"nowrap", position:"relative", top:"60%" }}>에스씨글로벌 B to B 서비스</p>    
              </div>
          </div> */}
      </div>
    </div>
  );
}

export default ServiceApply;
